import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {s_char_diary} from "../_signals/s_char";
import {ICharDiary} from "../_interfaces/ICharDiary";

export const DiaryGet = (cid: string) => {
    fetch(apiAddress + "/char/diary/" + cid, createOptions('GET'))
        .then((res) => res.json())
        .then((data) => {
                if (data.hasOwnProperty('result')) {
                    console.log('BEDiary get reponse', data.result);
                    s_char_diary.value = (data.result as ICharDiary[])
                }
            }
        )
        .catch((reason => {
            console.log('BEDiary get catch', reason);
        }))
}

export const DiaryCreate = (diary: ICharDiary) => {
    fetch(apiAddress + "/char/diary/", createOptions('CREATE', diary))
        .then((res) => res.json())
        .then((data) => console.log('BEDiary create reponse', data))
        .catch((reason => console.log('BEDiary create catch', reason)))
}

export const DiaryUpdate = (diary: ICharDiary) => {
    fetch(apiAddress + "/char/diary/", createOptions('UPDATE', diary))
        .then((res) => res.json())
        .then((data) => console.log('BEDiary update repsonse', data))
        .catch((reason => console.log('BEDiary update catch', reason)))
}

export const DiaryDelete = (diary: ICharDiary) => {
    fetch(apiAddress + "/char/diary/", createOptions('DELETE', diary))
        .then((res) => res.json())
        .then((data) => console.log('BEDiary delete repsonse', data))
        .catch((reason => console.log('BEDiary delete catch', reason)))
}